import { render } from "./CtaSection.vue?vue&type=template&id=4a2520d4&scoped=true"
const script = {}

import "./CtaSection.vue?vue&type=style&index=0&id=4a2520d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2520d4"]])

export default __exports__